import React from 'react'
import { useBuildReport } from '../../Hooks/Features/ServiceReports/useBuildReport'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BuildReport = ({ filterValues, setFilterValues }) => {
    const { rowData, columns, loader, detailsColumns, showPopup, setShowPopup, BuildDetailsExportToExcel } = useBuildReport({ filterValues, setFilterValues });
    return (
        <div className='m-2'>
            <div style={{ height: "calc(100vh - 100px)", overflow: "auto" }}>
                <CommonGrid
                    columns={columns}
                    data={rowData}
                    rowHeight={40}
                    loader={loader?.outer}
                    expandAll={true}
                />
            </div>
            {
                showPopup?.show && <Dialog visible={showPopup?.show} onHide={() => setShowPopup({ show: false })} className='modal-xlarge' draggable={false}
                    header={() => {
                        return <div>
                            {showPopup?.type} ({showPopup?.data[showPopup?.count]})
                        </div>
                    }}>
                    <div className='d-flex justify-content-between mb-1'>
                        <div className='fw-bold' style={{ fontSize: "18px" }}>{showPopup?.data?.project_Name}</div>
                        <button title="Download Excel" className="sk-btn sk-btn-primary" onClick={() => BuildDetailsExportToExcel()}><FontAwesomeIcon icon="fa-solid fa-download" /></button>
                    </div>
                    <CommonGrid
                        columns={detailsColumns}
                        data={showPopup?.rowData}
                        rowHeight={40}
                        loader={loader?.inner}
                        expandAll={true}
                    />
                </Dialog>
            }
            <Dialog visible={showPopup?.showJob} header="Services List" onHide={() => { setShowPopup((prev) => ({ ...prev, showJob: false, jobs: [] })); }} className="modal-small" draggable={false}>
                {showPopup?.jobs?.map(item => (
                    <div className='py-1 border-bottom'>{item}</div>
                ))}
            </Dialog>
        </div>
    )
}

export default BuildReport
